import React, { useState } from "react";
import Button from "../../../forms/Button";
import Radio from "../../../form/Radio";
import Textarea from "../../../form/Textarea";
import FileUploadMultiple from "../../../form/FileUploadMultiple";



const ReturnOrderModalContent = ({ setModalClose }) => {
  const [reasonForReturn, setReasonForReturn] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const [comments, setComments] = useState("");
  const radioOptions = [
    "Received the wrong item",
    "Item arrived damaged or defective",
    "Item is missing pages",
    "Product quality not as expected",
    "Changed my mind",
    "Late delivery",
    "Ordered by mistake",
    "Other (please specify)"
  ];

  const isOtherSelected = reasonForReturn === "Other (please specify)";
  return (
    <>
      <div className="space-y-6">
        <div className="space-y-2">
          <h3 className="text-2xl font-medium text-md-dark">Are you sure, you want to return your the order?</h3>
          <div className="text-base text-slate-500">By returning your order, the items will need to be picked up or shipped back to us. Once the returned items are received and inspected, your refund will be processed based on our return policy.</div>
          <div className="text-base text-slate-500">
            <ul className="list-disc list-outside pl-6">
              <li>Return Window: Returns are accepted within 7–10 days of delivery, depending on the product.</li>
              <li>Condition: Items must be unused, in original packaging, and include all tags/accessories.</li>
              <li>Refunds: Refunds are issued to the original payment method within 5–7 business days after inspection.</li>
            </ul>
          </div>
          <div className="text-sm text-slate-500">If you need assistance with the return process, please reach out to our support team.</div>
        </div>
        <div className="relative space-y-2">
          <h3 className="text-lg font-medium text-md-dark">Please select a reason for returning your order:</h3>
          <div className="relative grid grid-cols-2 gap-x-4 gap-y-2">
            {radioOptions.map((label, index) => (
              <Radio
                key={index}
                id={`reason-${label}`}
                radioName="reasonForReturn"
                radioInputClass=""
                radioLableClass="font-normal"
                isChecked={reasonForReturn === label}
                radioLabel={label}
                value={label}
                onChange={(e) => setReasonForReturn(e.target.value)}
              />
            ))}
          </div>
          {isOtherSelected && (
            <div className="relative">
              <Textarea inputPlaceholder={"Please specify your reason"} value={otherReason} onChange={(e) => setOtherReason(e.target.value)} />
            </div>
          )}
        </div>
        <div className="relative space-y-2">
          <h3 className="text-lg font-medium text-md-dark">Please upload images of the product:</h3>
          <div className="relative">
            <FileUploadMultiple />
          </div>
          <div className="relative">
            <Textarea inputPlaceholder={"Comments"} value={comments} onChange={(e) => setComments(e.target.value)} />
          </div>
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-md-pink-light-1 flex items-start justify-between gap-4">
        <div className="ml-auto flex-shrink-0 flex items-center gap-1 md:gap-2">
          <Button buttonHasLink={false} buttonIcon={"fa-regular fa-fw fa-xmark"} buttonIconPosition={"left"} buttonLabel={"Close"} buttonClasses={"!h-10 !rounded-md !px-3 !bg-md-pink-light-2 border border-md-pink-light-1 !text-md-pink hover:!bg-md-pink-light-1 hover:border-md-pink/20"} buttonLabelClasses={"!font-medium !pb-1 !leading-none"} buttonFunction={() => setModalClose(false)} />
          <Button buttonHasLink={false} buttonIcon={"fa-regular fa-fw fa-paper-plane-top"} buttonIconPosition={"left"} buttonLabel={"Submit"} buttonClasses={"!h-10 !rounded-md !px-3"} buttonLabelClasses={"!font-medium !pb-1 !leading-none"} buttonFunction={() => setModalClose(false)} />
        </div>
      </div>
    </>
  );
};

export default ReturnOrderModalContent;
